import type { ReactNode } from "react";
import { useCallback, useState } from "react";
import useLocalStorage from "use-local-storage";
// @ts-expect-error pure js
import useMediaQuery from "../../../hooks/use-media-query";
import { NavigationMenuContext } from "./navigation-menu-context.ts";

export function NavigationMenuProvider({ children }: { children: ReactNode }) {
  const isDesktop = useMediaQuery("(min-width: 871px)");
  const [desktopCollapsed, setDesktopCollapsed] = useLocalStorage(
    "navigationMenu_collapsed",
    false,
  );
  const [mobileCollapsed, setMobileCollapsed] = useState(true);

  const collapsed = isDesktop ? desktopCollapsed : mobileCollapsed;

  const toggleCollapsed = useCallback(() => {
    if (isDesktop) {
      setDesktopCollapsed((prev) => !prev);
    } else {
      setMobileCollapsed((prev) => !prev);
    }
  }, [isDesktop, setDesktopCollapsed]);

  const closeMobile = useCallback(() => {
    setMobileCollapsed(true);
  }, []);

  return (
    <NavigationMenuContext.Provider
      value={{
        collapsed,
        toggleCollapsed,
        closeMobile,
      }}
    >
      {children}
    </NavigationMenuContext.Provider>
  );
}
